import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacing.horizontalMedium};
  margin-bottom: ${tokens.spacing.verticalMedium};

  > h2:first-of-type {
    font-size: ${tokens.fontSize.medium};
    font-weight: ${tokens.fontWeights.regular};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    margin: 0;
  }

  hr {
    width: 100%;
  }
`

export const ItemContainer = styled.div`
  display: flex;
  gap: ${tokens.spacing.insetSmall};
  margin-top: ${tokens.spacing.verticalSmall};
  align-items: center;
  justify-content: space-between;

  padding: ${tokens.spacing.insetMedium};

  & > div:first-of-type {
    flex: 1;

    font-weight: ${tokens.fontWeights.regular};

    p {
      font-size: ${tokens.fontSize.medium};
      line-height: ${tokens.lineHeight.small}%;
      color: ${tokens.colors.dark5};
      margin: 0;
    }

    span {
      font-size: ${tokens.fontSize.small};
      line-height: ${tokens.lineHeight.small}%;
      color: ${tokens.colors.dark4};
      margin: 0;

      a {
        color: ${tokens.colors.dark4};
      }
    }
  }
`

export const AlertContainer = styled.div`
  display: flex;
  gap: ${tokens.spacing.insetSmall};
  justify-content: space-between;

  margin-top: ${tokens.spacing.verticalXsmall};

  padding: ${tokens.spacing.insetMedium};
  background-color: ${tokens.colors.warningMedium};
  border-radius: ${tokens.radius.medium};

  & > div:first-of-type {
    flex: 1;

    strong {
      font-size: ${tokens.fontSize.small};
      font-weight: ${tokens.fontWeights.bold};
      line-height: ${tokens.lineHeight.medium}%;
      color: ${tokens.colors.dark6};
      margin: 0;
    }

    li {
      font-size: ${tokens.fontSize.small};
      font-weight: ${tokens.fontWeights.regular};
      line-height: ${tokens.lineHeight.medium}%;
      color: ${tokens.colors.dark6};
      margin: 0;
    }

    ul {
      margin: ${tokens.spacing.verticalXsmall} 0 0
        ${tokens.spacing.horizontalMedium};
      padding: 0;
    }
  }
`

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
`
